var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 40,
    rx: 8,
    width: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.79 29.087c-.35 0-.669-.235-.741-.576a.716.716 0 01.394-.815c.074-.048.632-.437 1.19-1.617 1.025-2.166 1.24-5.216 1.24-7.394 0-3.93 3.197-7.127 7.127-7.127a7.135 7.135 0 017.127 7.127c0 2.178.215 5.228 1.24 7.394.558 1.18 1.116 1.57 1.19 1.617a.716.716 0 01.394.815c-.072.341-.392.576-.74.576zm12.688 1.144a3.787 3.787 0 01-.946 1.3c-.673.602-1.56.969-2.532.969s-1.86-.367-2.532-.97a3.825 3.825 0 01-.946-1.3zm3.714-3.596c-1.157-2.444-1.364-5.743-1.365-7.94v-.034A5.835 5.835 0 0020 12.858a5.835 5.835 0 00-5.827 5.827c0 2.196-.207 5.503-1.365 7.95-.224.473-.454.851-.672 1.152h15.727a7.268 7.268 0 01-.67-1.152zM22.564 8.941c.225.404.353.868.353 1.361v.112a8.464 8.464 0 00-1.32-.361 8.589 8.589 0 00-4.517.36v-.11A2.804 2.804 0 0119.882 7.5h.233c1.051-.001 1.97.581 2.449 1.44z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "media/icons/icn_bell-1e8f0f68.svg";
export { SvgIcnBell as ReactComponent };